/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface NumericConditionSetupParameterAssignment
 */
export interface NumericConditionSetupParameterAssignment {
    /**
     * 
     * @type {string}
     * @memberof NumericConditionSetupParameterAssignment
     */
    setupParameterId: string;
    /**
     * 
     * @type {number}
     * @memberof NumericConditionSetupParameterAssignment
     */
    value: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericConditionSetupParameterAssignment
     */
    $type?: NumericConditionSetupParameterAssignmentTypeEnum;
}


/**
 * @export
 */
export const NumericConditionSetupParameterAssignmentTypeEnum = {
    PtwPtw100AppZeroCoreSharedTaskItemComponentConditionValueAssignmentsNumericConditionSetupParameterAssignmentPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.NumericConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type NumericConditionSetupParameterAssignmentTypeEnum = typeof NumericConditionSetupParameterAssignmentTypeEnum[keyof typeof NumericConditionSetupParameterAssignmentTypeEnum];



/**
 * Check if a given object implements the NumericConditionSetupParameterAssignment interface.
 */
export function instanceOfNumericConditionSetupParameterAssignment(value?: unknown): value is NumericConditionSetupParameterAssignment {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericConditionSetupParameterAssignmentTypeEnum)[0];
}

export function NumericConditionSetupParameterAssignmentFromJSON(json: any): NumericConditionSetupParameterAssignment {
    return NumericConditionSetupParameterAssignmentFromJSONTyped(json, false);
}

export function NumericConditionSetupParameterAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericConditionSetupParameterAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'setupParameterId': json['setupParameterId'],
        'value': json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericConditionSetupParameterAssignmentToJSON(value?: NumericConditionSetupParameterAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'setupParameterId': value['setupParameterId'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

